export const Logo = {
    MD_SIR_SIGNATURE: require('../static/img/mdsir.png'),
    SCHOOL_LOGO_JPG: require('../static/img/hurdcoLogo.jpeg'),
    SCHOOL_LOGO_PNG: require('../static/img/HURDCO_logo.png'),
    SCHOOL_LOGO_NEW_PNG: require('../static/img/new-logo.png'),
    SCHOOL_LOGO_WITH_NAME_PNG: require('../static/img/logo.png'),
    GET_CONNECT_LOGO: require('../static/img/invoice/myLgo.png')
};